<!-- TODO: this can be removed since we're not allowing users to access home without logging in -->
<div class="wrapper not-logged-in" *ngIf="!isLoggedIn">
  <div class="map-view-wrapper">
    <div id="home-map"></div>

    <div class="blur-map"></div>
    <div class="map-content">
      <app-home-welcome-guest></app-home-welcome-guest>
      <app-shared-button theme="outline" (click)="showAuthModal('signin')">
        Sign in
      </app-shared-button>
      <div class="mt-4">
        <app-shared-button (click)="showAuthModal('signup')">
          Create account
        </app-shared-button>

        <app-submit-a-deal-button
          [wrapper]="submitDealWrapper"
        ></app-submit-a-deal-button>
        <ng-template #submitDealWrapper let-text let-handleClick="handleClick">
          <div class="mt-4">
            <app-shared-button (click)="handleClick()" theme="secondary">
              {{ text }}
            </app-shared-button>
          </div>
        </ng-template>
      </div>
      <div class="mt-3 text-sm text-center">
        For support: Email us at
        <a href="mailto:help@rebuilt.com">{{ 'help@rebuilt.com' }}</a>
      </div>
    </div>
  </div>

  <app-home-list-view
    class="list"
    [properties]="properties"
    [loading]="loading"
    [isLoggedIn]="isLoggedIn"
  ></app-home-list-view>
</div>

<div
  *ngIf="isLoggedIn"
  class="wrapper logged-in"
  [ngClass]="[viewMode === 'map' ? 'map-view' : '', marketplaceType]"
>
  <app-home-map-list-switcher
    [isMapView]="viewMode === 'map'"
    (switchMapView)="toggleViewVode()"
  ></app-home-map-list-switcher>

  <div class="map-view-wrapper" [ngClass]="{ hidden: viewMode !== 'map' }">
    <div id="home-map"></div>
  </div>

  <app-home-list-view
    *ngIf="viewMode === 'list'"
    class="list"
    [properties]="properties"
    [loading]="loading"
    [isLoggedIn]="isLoggedIn"
  ></app-home-list-view>
</div>
